<template>
    <div>
        <div style="width: 90%">
            <b-card bg-variant="light">

                <b-row>
                    <b-col cols="4"></b-col>
                    <b-col cols="8"><span style="font-size: 20px; font-weight: bold"> To reset your password, please enter a new password.</span>
                    </b-col>
                </b-row>
                <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="New Password:"
                              label-for="input-sm">

                    <b-input type="password" id="text-password-new" aria-describedby="password-help-block"
                             v-model="newPassword"></b-input>
                </b-form-group>
                <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Confirm New Password:"
                              label-for="input-sm">

                    <b-input type="password" id="text-password-confirm"
                             aria-describedby="password-help-block" v-model="newPasswordConfirm"></b-input>
                    <b-form-text id="password-help-block">
                        Your password must be 8-20 characters long, contain letters and numbers, and must not
                        contain spaces, special characters, or emoji.
                    </b-form-text>

                </b-form-group>
                <div class="button-holder">
                    <b-button class="submit-button" type="submit" v-bind:disabled=isNotClickable @click="updatePassword"
                              variant="primary">Reset
                    </b-button>

                    <b-button class="cancel-button" type="cancel" @click="cancel" variant="primary">Cancel</b-button>
                </div>
            </b-card>
            <b-modal id="modal-1" title="Password Update Status" effect="fade/zoom" hide-footer>
                <div>
                    <p class="my-4">{{ updateMessage }}</p>
                    <div slot="modal-footer" class="modal-footer">
                    </div>
                    <b-button type="button" class="btn btn-default mt-3" @click="dismissTheModal">Continue</b-button>
                </div>
            </b-modal>
        </div>
    </div>

</template>

<script>
import VueInputUi from 'vue-input-ui'

export default {
  name: "PasswordReset.vue",
  components: {
    VueInputUi
  },
  data() {
    return {
      darkMode: false,
      newPassword: '',
      newPasswordConfirm: '',
      passwordUpdateStatus: false,
                isNotClickable: false,
                updateMessage: ''
            }
        },
        computed: {
            validation() {
                return this.userId.length > 4 && this.userId.length < 13
            }
        },
        methods: {
            updatePassword: function () {
                let self = this;
                this.isNotClickable = false;
                if ((this.newPasswordConfirm === this.newPassword) && (this.newPassword !== "")) {
                    this.$http.put("account/password/" + self.$route.query.id, {
                            token: self.$route.query.id,
                            password: self.newPassword
                        },
                        {
                            headers: {
                                'content-type': 'application/json'
                            },
                        }).then(result => {
                        if (result.status === 202) {
                            let updateResult = result.data;
                            console.log(updateResult);
                            if (updateResult.result === 'SUCCESSFUL') {
                                this.passwordUpdateStatus = true;
                                this.updateMessage = "Password Update Succeeded. Please Login to continue.";
                            } else {
                                this.passwordUpdateStatus = false;
                                this.updateMessage = "Password Update Failed";
                            }
                            this.$bvModal.show("modal-1");
                        }
                    }).catch(error => {
                        console.log("Something went wrong" + error);
                        this.updateMessage = "Password Reset Request Failed";
                        this.$bvModal.show("modal-1");
                    });
                } else {
                    console.log("A password must be present");
                    this.updateMessage = "Passwords Must match";
                    this.$bvModal.show("modal-1");
                }
                this.isNotClickable = false;
            },
            cancel: function () {
                this.$router.push("/login");
            },
            dismissTheModal: function () {
                this.newPassword = '';
                this.newPasswordConfirm = '';
                this.currentPassword = '';
                this.$bvModal.hide("modal-1");
                if (this.passwordUpdateStatus === true) {
                    this.$router.push("/login");
                }

            }
        }
    }
</script>

<style scoped>
    .cancel-button {
        margin-left: 10px;
        margin-top: 5px;
    }

    .submit-button {
        margin-left: 10px;
        margin-top: 5px;
    }

    .button-holder {
        horiz-align: center;
        display: flex; /*Requires vendor prefixes*/
        justify-content: center; /*Requires vendor prefixes*/
        align-items: center; /*Requires vendor prefixes*/
    }
</style>
